import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import fields from '../../lib/fields';

import ImageScroller from '../../components/imagescroller';
import PaymentAmount from './paymentAmount';
import VippsCheckoutModal from './vippsCheckoutModal';

import localUtil from '../../lib/util';

@withText(props => ({
    amountText: <Text id='race-class.signup.amount-title'>Amount to pay</Text>,
}))
@observer
class PaymentVipps extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            showCheckoutModal: false,
            checkoutAmount: null,
            checkoutTitle: null,
            checkoutType: null,
            checkoutCustomer: null,
            checkoutRaceClassContestant: null,
        };
        this.mainContainer = null;
    }

    doPayment = async () => {
        const { type, amount, raceId } = this.props;
        const { raceClassContestantStore, userStore } = this.props.stores;
        const { user } = userStore;
        const { raceClassContestant } = raceClassContestantStore;

        switch (type) {
            case 'fee':
                if (raceClassContestant.paymentMethod === 'paypal') {
                    return this.paymentPaypal();
                }
                this.setState({
                    showCheckoutModal: true,
                    checkoutAmount: raceClassContestant.signupfeeAmount,
                    checkoutTitle: `Race signup fee - ${raceClassContestant.name}`,
                    checkoutType: 'signupfee',
                    checkoutCustomer: raceClassContestant.customer,
                    checkoutRaceClassContestant: raceClassContestant.id,
                });
                break;
            case 'signup':
                if (raceClassContestant.paymentMethod === 'paypal') {
                    return this.paymentPaypal();
                }
                this.setState({
                    showCheckoutModal: true,
                    checkoutAmount: raceClassContestant.signuppaymentAmount,
                    checkoutTitle: `Race signup - ${raceClassContestant.name}`,
                    checkoutType: 'signup',
                    checkoutCustomer: raceClassContestant.customer,
                    checkoutRaceClassContestant: raceClassContestant.id,
                });
                break;
            case 'rest':
                if (raceClassContestant.paymentMethod === 'paypal') {
                    return this.paymentPaypal();
                }
                this.setState({
                    showCheckoutModal: true,
                    checkoutAmount: raceClassContestant.restPaymentAmount,
                    checkoutTitle: `Race rest payment - ${raceClassContestant.name}`,
                    checkoutType: 'rest',
                    checkoutCustomer: raceClassContestant.customer,
                    checkoutRaceClassContestant: raceClassContestant.id,
                });
                break;
            case 'subscription':
                if (user.paymentMethod === 'paypal') {
                    return this.paymentPaypal();
                }
                this.setState({
                    showCheckoutModal: true,
                    checkoutAmount: amount || user.subscriptionPaymentAmount,
                    checkoutTitle: 'Subscription payment',
                    checkoutType: 'subscription',
                    checkoutCustomer: user.customer,
                    checkoutRaceClassContestant: null,
                });
                break;
            default:
                break;
        }
    }

    handleCheckoutComplete = async ({ paymentUuidv4 }) => {
        const { type } = this.props;
        const { raceClassContestantStore, userStore } = this.props.stores;
        const { raceClassContestant } = raceClassContestantStore;

        this.setState({ showCheckoutModal: false });

        // Reload the relevant data to reflect paid status
        switch (type) {
            case 'fee':
            case 'signup':
            case 'rest':
                if (raceClassContestant?.uuidv4) {
                    await raceClassContestantStore.load({ uuidv4: raceClassContestant.uuidv4 });
                }
                break;
            case 'subscription':
                await userStore.load();
                break;
            default:
                break;
        }
    }

    handleCheckoutCancel = () => {
        this.setState({ showCheckoutModal: false });
    }

    payment = () => {
        const { type, amount } = this.props;
        const { paymentInProgress } = this.state;
        const { raceClassContestantStore, userStore } = this.props.stores;
        const { user } = userStore;
        const { raceClassContestant } = raceClassContestantStore;

        return (<>
            <img src={'/assets/external/Pay_pill - NO.png'} style='width: 180px;' onClick={this.doPayment} />
        </>);
    }

    // The header and the receipt must show the same currency. NOK is only PaymentAmount's
    // fallback, so a SEK or EUR race is never labelled NOK here.
    getCurrency = () => {
        const { type } = this.props;
        const { raceClassContestantStore, userStore } = this.props.stores;
        const { raceClassContestant = {} } = raceClassContestantStore;
        const { user = {} } = userStore;
        if (type === 'subscription') {
            return user.subscriptionCurrency;
        }
        return raceClassContestant.requiredPaymentCurrency;
    }

    receipt = () => {
        const { type } = this.props;
        const { raceClassContestantStore, userStore } = this.props.stores;
        const { raceClassContestant } = raceClassContestantStore;
        const { user } = userStore;

        let amount = 0;
        let currency = '';
        let paidDate = null;
        switch (type) {
            case 'fee':
                amount = raceClassContestant.vippsSignupfeeAmountValue;
                currency = raceClassContestant.vippsSignupfeeAmountCurrency;
                paidDate = raceClassContestant.paidSignupfee;
                break;
            case 'signup':
                amount = raceClassContestant.vippsSignupAmountValue;
                currency = raceClassContestant.vippsSignupAmountCurrency;
                paidDate = raceClassContestant.paidSignup;
                break;
            case 'rest':
                amount = raceClassContestant.vippsRestAmountValue;
                currency = raceClassContestant.vippsRestAmountCurrency;
                paidDate = raceClassContestant.paidRest;
                break;
            case 'subscription':
                amount = user.vippsSubscriptionAmountValue;
                currency = user.vippsSubscriptionAmountCurrency;
                paidDate = user.paidSubscription;
                break;
            default:
                break;
        }

        return (<>
             <div class='d-flex flex-row justify-content-center align-items-center mt-0'>
                <img src={'/assets/external/Vipps logo.png'} style='width: 64px;' />
            </div>
            <div class='d-flex flex-row justify-content-center align-items-center mt-0'>
                <div>
                    <i class='fa-regular fa-circle-check text-success' style='font-size: 4.0em;' />
                </div>
                <div class='d-flex flex-column ms-3'>
                    <PaymentAmount
                        stores={this.props.stores}
                        title={util.formatDate(paidDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                        amount={amount / 100}
                        currency={currency}
                    />
                </div>
            </div>
        </>);
    }

    render() {
        const { paymentInProgress, showCheckoutModal, checkoutAmount, checkoutTitle, checkoutType, checkoutCustomer, checkoutRaceClassContestant } = this.state;
        const {
            amountText,
        } = this.props;
        const { type, raceId } = this.props;
        const { appState, userStore, raceClassContestantStore } = this.props.stores;
        const { user = {}, isAdmin, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { raceClassContestant } = raceClassContestantStore;

        let amount = 0;
        let paidDate = null;
        switch (type) {
            case 'fee':
                amount = raceClassContestant.signupfeeAmount;
                paidDate = raceClassContestant.paidSignupfee;
                break;
            case 'signup':
                amount = raceClassContestant.signuppaymentAmount;
                paidDate = raceClassContestant.paidSignup;
                break;
            case 'rest':
                amount = raceClassContestant.restPaymentAmount;
                paidDate = raceClassContestant.paidRest;
                break;
            case 'subscription':
                amount = user.subscriptionPaymentAmount;
                paidDate = user.paidSubscription;
                break;
            default:
                break;
        }

        return (<>

            {paidDate ? <>
                {this.receipt()}
            </> : <>
                <div class='d-flex flex-row justify-content-center mt-0'>
                    <PaymentAmount
                        stores={this.props.stores}
                        title={amountText}
                        amount={amount}
                        currency={this.getCurrency()}
                    />
                </div>
                <div class='d-flex flex-row justify-content-center mt-0'>
                    {this.payment()}
                </div>
            </>}

            {showCheckoutModal && (
                <VippsCheckoutModal
                    stores={this.props.stores}
                    amount={checkoutAmount}
                    title={checkoutTitle}
                    type={checkoutType}
                    customer={checkoutCustomer}
                    raceClassContestant={checkoutRaceClassContestant}
                    race={raceId}
                    onComplete={this.handleCheckoutComplete}
                    onCancel={this.handleCheckoutCancel}
                />
            )}

        </>);
    }
}

export default PaymentVipps;
